import { Component, Input, OnInit } from '@angular/core';
import { ConfigQuestion } from '../../models/config-question.interface';
import {
	ControlValueAccessor,
	UntypedFormControl,
	UntypedFormGroup,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ErrorMessage } from '../../constants/enum.const';

@Component({
	selector: 'bcb-generic-text-area',
	templateUrl: './generic-text-area.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: GenericTextAreaComponent,
		},
	],
	styleUrls: ['./generic-text-area.component.scss'],
})
export class GenericTextAreaComponent implements ControlValueAccessor, OnInit {
	@Input() question!: ConfigQuestion;
	@Input() formGroup?: UntypedFormGroup;
	@Input() formControl?: UntypedFormControl;
	@Input() formControlName?: string;
	@Input() errorMessage: ErrorMessage | undefined;

	value: any;
	isDisabled: boolean = false;

	constructor() {}

	ngOnInit(): void {
		if (this.formControl) {
			this.formGroup = this.formControl.parent as UntypedFormGroup;
		} else if (this.formGroup && this.formControlName) {
			this.formControl = this.formGroup.get(
				this.formControlName
			) as UntypedFormControl;
		} else {
			throw new Error(
				'One of the following is required: [formControl] or [formControlName] + [FormGroup]'
			);
		}
	}

	changed: (value: any) => void = () => {};

	touched: () => void = () => {};

	writeValue(obj: any): void {
		this.value = obj;
	}

	onChange(event: Event): void {
		this.changed((<HTMLInputElement>event.target)?.value);
	}

	registerOnChange(fn: any): void {
		this.changed = fn;
	}

	registerOnTouched(fn: any): void {
		this.touched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}
